export default __webpack_public_path__ + "static/media/consol-2-en.3b5f9b31.svg";